<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Halftitle">
<p class="halftitle"><span class="right_1" epub:type="pagebreak" id="page_i" title="i">HUMANE MUSIC EDUCATION<br/>FOR THE COMMON GOOD</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00a_Yob_and_Jorgensen_fm_prod0.vue?deeddcdc